// extracted by mini-css-extract-plugin
export default {"button":"Button_button__O+4gT","inverted":"Button_inverted__6cSHs","disabled":"Button_disabled__7Gyvl"};